Vue.config.productionTip = false
Vue.config.devtools = true;
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import App from './App.vue'
import './assets/css/main.css'
import store from './store';



new Vue({
  store,
  render: h => h(App),
}).$mount('#app')

